import * as API from '@/api'
import DEFINES from '@/defines'
import { getField, updateField } from 'vuex-map-fields';
//initial state
function initialState() {
    return {
        list: [],
        subscription: null,
        paymentMethod: null,
        company:null,
        invoices: null,
        usage:null
    }
}
const state = initialState()

// actions

const actions = {
    async list(context, payload) {
        var response = await API.adminSubscription.list(payload)
        context.commit('set_list', response)
        return response;
    },
    async get_subscription(context, payload) {
        var response = await API.adminSubscription.get(payload)
        context.commit('set_data',response);
        return response;
    },
    async cancel(context, payload) {
        var response = await API.adminSubscription.cancel(payload)
        context.commit('set_data',response);
        return response;
    },
    async resume(context, payload) {
        var response = await API.adminSubscription.resume(payload)
        context.commit('set_data',response);
        return response;
    }
}


//getters

const getters = {
    getField,
}


// mutations
const mutations = {
    updateField,
    set_list(state, payload) {
        state.list = payload.subscriptions
    },
    set_data: (state, payload) => {
        state.subscription = payload.subscription
        state.paymentMethod = payload.paymentMethod
        state.company = payload.company
        state.invoices = payload.invoices
        state.usage = payload.usage
    },
    reset(state) {
        // acquire initial state
        const s = initialState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
